export const camelCaseSeparator = (str: string) => str.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
export const idGenerator = () => (Math.random() + 1).toString(36).substring(7)
